/**
 * Page to display all products of my company
 * /moja-firma/proizvodi
 */

import React, { useEffect, useMemo, useState } from 'react'
import { Button, Container } from 'react-bootstrap'
import { Footer, KonektoNavbar } from '../../components'
import '../../../src/App.scss'
import './MyCompanyProducts.scss'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getMyCompanyProducts } from '../../store/Actions/Company'
import placeholderImage from '../../assets/images/detailsPlaceholder.jpg'
import { hasValue } from '../../helpers'
import { FaEye, FaPlus } from 'react-icons/fa'

export default function MyCompanyProducts() {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { token } = useSelector(state => state.authentication)
  const { myCompany, products } = useSelector(state => state.company)

  const [productsList, setProductsList] = useState(products) // full list or search result

  const [searchQuery, setSearchQuery] = useState('')

  useEffect(() => {
    if (hasValue(searchQuery)) {
      const lowercasedSearchQuery = searchQuery.toLowerCase()
      const searchResult = productsList.filter(p =>
        p.title.toLowerCase().includes(lowercasedSearchQuery),
      )
      setProductsList(searchResult)
    } else {
      setProductsList(products)
    }
  }, [searchQuery])

  const emptyListMessage = useMemo(() => {
    if (productsList.length > 0) {
      return ''
    }

    if (hasValue(searchQuery)) {
      return `Nema rezultata za "${searchQuery}"`
    } else {
      return 'Vaša lista proizvoda je prazna'
    }
  }, [productsList, searchQuery])

  useEffect(() => {
    if (!token) {
      navigate('/prijava')
      return
    }

    if (myCompany === null) {
      navigate('/registracija-firme')
      return
    }
  }, [token, myCompany, navigate])

  useEffect(() => {
    if (myCompany?.id && token) {
      dispatch(getMyCompanyProducts())
    }
  }, [myCompany, token])

  useEffect(() => {
    setProductsList(products)
  }, [products])

  return (
    <div id="my-company-products">
      <KonektoNavbar />
      <Container className="my-5">
        <h3 className="fw-bold">{`Proizvodi i Servisi`}</h3>

        <div className="group-wrapper shadow">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
            <input
              type="text"
              className="form-control rounded-pill"
              placeholder="Pretraži ime proizvoda"
              aria-label="Pretraga"
              value={searchQuery}
              onChange={e => {
                setSearchQuery(e.target.value)
              }}
            />
            <Button
              onClick={() => {
                navigate('/moja-firma/proizvod')
              }}
              variant="primary"
              type="button"
              className="px-4 rounded-pill">
              <span className="me-2">Dodaj proizvod</span>
              <FaPlus />
            </Button>
          </div>

          <hr className="hr divider" />

          {productsList?.length > 0 ? (
            <div>
              {productsList.map((product, index) => {
                let image = placeholderImage
                if (product?.images?.length > 0) {
                  image = product.images[0].path
                }

                return (
                  <div
                    key={product.id}
                    className="product-row pointer"
                    onClick={() => {
                      navigate(`/moja-firma/proizvod/${product.id}`)
                    }}>
                    <div className="d-flex justify-content-between">
                      <div className="d-flex">
                        <img src={image} />
                        <h6 className="mt-1 ms-2">{product.title}</h6>
                      </div>

                      <div className="d-flex align-items-center">
                        {product.is_available ? null : (
                          <div className="product-status">{`Nedostupan`}</div>
                        )}

                        <div
                          className="product-views ms-3"
                          title="Broj pregleda">
                          <FaEye />
                          <span className="ms-1">{product.views ?? 0}</span>
                        </div>
                      </div>
                    </div>

                    {index < productsList.length - 1 ? (
                      <hr className="hr divider" />
                    ) : null}
                  </div>
                )
              })}
            </div>
          ) : (
            <p className="text-center mt-4 warning-text">{emptyListMessage}</p>
          )}
        </div>
      </Container>
      <Footer />
    </div>
  )
}
